import { CustomField } from '@domain/product/models/CustomField';
import { CustomFieldDTO } from '../dto/CustomFieldDTO';

export class CustomFieldMapper {
  static toModel(dto: CustomFieldDTO): CustomField {
    return {
      id: dto.id,
      key: dto.key,
      label: dto.label,
    };
  }
}
